import * as HTTP from './http';

export const GetAuthLink = async() => {
    let endpoint = `gugle/auth/link`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: gugle.GetAuthLink\n${e}`);
        return undefined;
    }

    return result;
}

export const GetAuthTokens = async(code) => {
    let endpoint = `gugle/auth/tokens/${encodeURIComponent(code)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: gugle.GetAuthTokens\n${e}`);
        return undefined;
    }

    return result;
}

export const ReportsRebeca001 = async(payload) => {
    let endpoint = `gugle/reports/rebeca/001`;

    try{
        var result = await HTTP.POST(endpoint, payload);
    }catch(e){
        console.log(`CONTROLLER ERROR: gugle.ReportsRebeca001\n${e}`);
        return undefined;
    }

    return result;
}

export const RefreshToken = async(payload) => {
    let endpoint = `gugle/auth/refresh`;

    try{
        var result = await HTTP.POST(endpoint, payload);
    }catch(e){
        console.log(`CONTROLLER ERROR: gugle.RefreshToken\n${e}`);
        return undefined;
    }

    return result;
}

export const GetGugle = async() => {
    let endpoint = `gugle`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: gugle.GetGugle\n${e}`);
        return undefined;
    }

    return result;
}